import HomePageShortcuts from './HomePageShortcuts.js';

function HomePage() {
  return (
    <div
      className="HomePage"
      data-testid="HomePage"
      style={{ padding: '0 20px' }}
    >
      <h1>Component Page</h1>
      <p>Links to pages that render available components:</p>
      <HomePageShortcuts pathPrefix="/components" />

      <h1>Test Page</h1>
      <p>
        Links to pages that render available components inside an iframe
        (similar to production):
      </p>
      <HomePageShortcuts pathPrefix="/test" />
    </div>
  );
}

export default HomePage;
